import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'
import { Country } from '@/travelsuit'

import { IAction } from '../actions/action-helpers'
import { CountriesTypes } from '../actions/actions.types'

type CountriesState = ApplicationState['countries']

const defaultState: CountriesState = {
	byName: new ImmutableMap(),
	byISO: new ImmutableMap(),
	countries: [],
	cached: false,
}

function mapCountriesCache(cache: Country[], state: CountriesState) {
	const cachedState = cache.reduce(
		(newState, country) => ({
			...newState,
			byName: newState.byName.set(country.name, country),
			byISO: newState.byISO.set(country.iso, country),
		}),
		state,
	)

	return {
		...cachedState,
		countries: cache,
		cached: cachedState.byISO.size > 0,
	}
}

function countriesReducer(state: CountriesState = defaultState, action: IAction): CountriesState {
	switch (action.type) {
		case CountriesTypes.GetCountries.SUCCESS:
			return mapCountriesCache(action.payload, state)
	}
	return state
}

export default countriesReducer
